import { connect } from 'react-redux';
import { compose, lifecycle, withState, withHandlers } from 'recompose';

import API from 'utils/api';
import { SourceGroup } from 'helpers/axios';
import { open } from 'store/modules/modal';

import ChannelForm from '../components/ChannelForm';

const mapStateToProps = ({ auth }) => ({ auth });

const mapDispatchToProps = dispatch => ({
  showError: message => {
    dispatch(
      open({
        modalType: 'error',
        modalProps: { message },
      })
    );
  },
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),

  withState('sources', 'setSources', new SourceGroup()),
  withState('channelData', 'setChannelData', null),

  withHandlers({
    onSubmit:
      props =>
      async ({ name, token, mobile }, { setSubmitting }) => {
        const { id } = props.channelData;
        const data = { name, token, mobile };

        const { error } = id
          ? await API.editChannel(id, data, props.sources)
          : await API.createChannel(data, props.sources);

        setSubmitting(false);

        if (error) {
          props.showError(error);
        } else {
          props.history.push('/dashboard/channel/admin');
        }
      },
  }),

  lifecycle({
    componentDidMount() {
      if (this.props.location.state) {
        const { id, name, token, mobile } = this.props.location.state;
        this.props.setChannelData({ id, name, token, mobile: !!mobile });
      } else {
        this.props.setChannelData({ name: '', token: '', mobile: false });
      }
    },
    componentWillUnmount() {
      this.props.sources.cancelAll();
    },
  })
);

export default enhance(ChannelForm);
